import { ReactComponent as MailSvg } from '../assets/mail.svg';

const MailIcon = () => (
  <MailSvg />
);

export default MailIcon;
